<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on">
        <v-icon> remove_red_eye </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-row class="d-flex align-center justify-center">
          Alert Details
        </v-row>
      </v-card-title>
      <v-card-text v-if="alert != null">
        <v-container>
          <v-row class="d-flex align-center justify-center">
            <p>
              {{getLabelWithUnitFromPathFieldDescription(
          ['name'],
          context
        ),}}
              :&nbsp;
            </p>
            <p>
              {{
                this.getDisplayValueFromPathFieldDescription(
                  alert.name,
                  ['name'],
                  context
                )
              }}
            </p>
          </v-row>
          <v-row class="d-flex align-center justify-center">
            <p>{{ numberOfSpaceObjectGroup }}</p>
          </v-row>
          <v-row class="d-flex align-center justify-center">
            <ScreeningAlertText :alert="alert" />
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TooltipText from './TooltipText'
import ScreeningAlertText from './ScreeningAlertText.vue'
import defense from '../../mixins/defense'

export default {
  name: 'ScreeningAlertVisualizationDialogue',

  components: {
    TooltipText,
    ScreeningAlertText
  },

  props: {
    alert: {
      type: Object
    }
  },
  mixins: [defense],

  data() {
    return {
      dialog: false,
      context: 'AbstractAlertDefinition',
      spaceObjectGroupsDialogText: {
        scopeUserDefined: 'Number of space object group in this alert : ',
        scopeAll: 'This alert apply to all space oject group.'
      }
    }
  },

  computed: {
    numberOfSpaceObjectGroup() {
      if (this.alert.primarySpaceObjectGroups !== null) {
        return (
          this.spaceObjectGroupsDialogText.scopeUserDefined +
          this.alert.primarySpaceObjectGroups.length
        )
      } else {
        return this.spaceObjectGroupsDialogText.scopeAll
      }
    }
  }
}
</script>
